import script from "./AiCheckList.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckList.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckList.vue?vue&type=style&index=0&id=1745e5b2&lang=css"

const __exports__ = script;

export default __exports__